module.exports = __webpack_public_path__ + "static/media/docIcon.09c1b39a.svg";